import { render } from "./RegistrationServiceBus.vue?vue&type=template&id=3996e6bc&scoped=true"
import script from "./RegistrationServiceBus.vue?vue&type=script&lang=js"
export * from "./RegistrationServiceBus.vue?vue&type=script&lang=js"

import "./RegistrationServiceBus.vue?vue&type=style&index=0&id=3996e6bc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3996e6bc"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBtn,QTooltip,QBanner,QIcon});
